import React, { useRef, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";


function AddCategory() {
  const [categoryName, setCategoryName] = useState("");
  const [catimg, setCatimg] = useState(null);
  const fileInputRef = useRef(null); // Reference for file input

  const handleSubmit = async () => {
    if (!categoryName.trim() || !catimg) {
      toast.error("Please enter a category name and select an image."); // Show error toast
      return;
    }

      const formData = new FormData();
    formData.append("categoryName", categoryName);
    formData.append("catimg", catimg);

    try {
      const response = await axios.post(
        "https://visitguru.in/api/v1/category/addCategory",
        formData
      );

      if (response.data.success === true) {
        // console.log("Category added");
        toast.success("Category added successfully!"); // Success toast
        setCategoryName(""); // Clear input field
        setCatimg(null); // Clear file state

        // Reset file input field
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      }
    } catch (error) {
      console.error("Error adding category:", error);
      toast.error("Failed to add category. Please try again."); // Error toast
    }
  };

  return (
    <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
     
      <div className="rounded-t bg-white mb-0 px-6 py-6">
        <div className="text-center flex justify-between">
          <h6 className="text-blueGray-700 text-xl font-bold">Add Category</h6>
        </div>
      </div>
      
      <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="flex flex-wrap">
            <div className="w-full lg:w-12/12 px-4">
              <div className="relative w-full mb-3">
                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-4">
                  Category Name
                </label>
                <input
                  type="text"
                  className="border-0 px-3 py-3 mt-2 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Enter Category Name"
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                />
              </div>

              <div className="relative w-full mb-3">
                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-4">
                  Category Image
                </label>
                <input
                  type="file"
                  ref={fileInputRef} // Attach ref here
                  className="border-0 px-3 py-3 mt-2 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  onChange={(e) => setCatimg(e.target.files[0])}
                />
              </div>
            </div>
          </div>

          <div className="flex justify-end w-full">
            <button
              className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs mt-2 px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
              type="button"
              onClick={handleSubmit}
            >
              Add Category
            </button> 
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddCategory;
